import { ElementType, JSX } from 'react';
import './structured-content-debugger.css';
import { StructuredContentNode } from '@nerdwallet/structured-content-core';

function renderNode(
  node: StructuredContentNode,
  Component: ElementType | any
): JSX.Element {
  const nodeProps = node;

  const style = {
    border: '1px dashed pink',
    position: 'relative',
  };

  return (
    // a span wrapping this component may cause the page to render incorrectly but without it some of the components to not respect the custom sc-test-id attribute.
    // eslint-disable-next-line react/no-unknown-property
    <span sc-test-id={`${node.type} ${Component.isCodesplit ? '💤' : '⚡️'}`}>
      <Component {...nodeProps.props} style={style} />
    </span>
  );
}

export default renderNode;
